import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { SecureStorageWrapperService } from '@core/services/system/secure-storadge/secure-storage-wrapper.service';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { IonicImageLoaderModule } from '@shared/components/ionic-image-loader-v5';
import { AppMainModule } from './app.component';
import { CoreModule } from '@core/core.module';
import { PaymentProcessingModule } from '@shared/components/payment-processing/payment-processing.module';
import { GiftCardModule } from '@features/gift-card';
import { AppRoutingModule } from '@routing/app-routing.module';
import { IonicModule } from '@ionic/angular';
import { MyPosModule } from '@features/my-pos/my-pos.module';
import { MyPosMiniModule } from '@features/my-pos-mini/my-pos-mini.module';
import { ServicesModule } from '@core/services/services.module';
import { CurrentUserModule } from '@shared/components/current-user/current-user.component';
import { NotifyPopupsModule } from '@shared/components/notify-popups/notify-popups.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { IonicStorageModule } from '@ionic/storage-angular';
import { ApiModule } from '@core/services/api/api.module';
import { ReceiptPrintersModule } from '@core/services/system/receipt-printers/receipt-printers.module';
import { DbModule } from '@core/services/db/db.module';
import { LoggerModule } from '@core/services/system/logger/logger.module';
import { NullifyModalModule } from '@shared/components/nullify-modal/nullify-modal.component';
import { PreloadNextModules } from '@routing/preload-next-modules';
import { initSentry } from './sentry';
import { MenuComponentModule } from '@shared/components/menu/menu.component';
import { PAYMASH_ENV } from '@environment';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { reducers } from '@state/reducers';
import { effects } from '@state/effects';
import { facades } from '@state/facades';
import { CART_INTERACTION_COORDINATOR_PROVIDER } from '@core/services/system/cart';

const disableAnimations =
  !('animate' in document.documentElement) || (navigator && /iPhone OS (8|9|10|11|12|13)_/.test(navigator.userAgent) && window.cordova);

if (window.cordova) {
  initSentry();
}

export function translateLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule.withConfig({ disableAnimations }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: translateLoaderFactory,
        deps: [HttpClient],
      },
    }),
    IonicImageLoaderModule,
    CoreModule,
    GiftCardModule.forRoot(),
    MyPosModule,
    MyPosMiniModule.forRoot(),
    PaymentProcessingModule.forRoot(),
    IonicModule.forRoot({ innerHTMLTemplatesEnabled: true } as any),
    AppRoutingModule,
    ServicesModule,
    CurrentUserModule,
    NotifyPopupsModule,
    IonicStorageModule.forRoot(),
    ApiModule.forRoot(),
    ReceiptPrintersModule.forRoot(),
    DbModule,
    LoggerModule,
    NullifyModalModule,
    MenuComponentModule,
    StoreModule.forRoot(reducers),
    EffectsModule.forRoot(effects),
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: PAYMASH_ENV.enabledConsoleOutput, // Restrict extension to log-only mode
      autoPause: true, // Pauses recording actions and state changes when the extension window is not open
    }),
  ],
  providers: [
    PreloadNextModules,
    facades,
    CART_INTERACTION_COORDINATOR_PROVIDER,
    provideHttpClient(withInterceptorsFromDi()),
    // Blocks app bootstrap (and therefore every component/service/HTTP request)
    // until Secure Storage is ready, so device data is available before any POS operation.
    {
      provide: APP_INITIALIZER,
      useFactory: (secureStorage: SecureStorageWrapperService) => () => secureStorage.init(),
      deps: [SecureStorageWrapperService],
      multi: true,
    },
  ],
  declarations: [AppMainModule],
  bootstrap: [AppMainModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
